module.exports = __webpack_public_path__ + "img/placeholder-artist.3413206c.svg";